/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Shipping_Adjustment_Created_With_LinkInputs */

const en_shipping_adjustment_created_with_link = /** @type {(inputs: Shipping_Adjustment_Created_With_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shipping adjustment created. Payment link: ${i?.url}`)
};

const es_shipping_adjustment_created_with_link = /** @type {(inputs: Shipping_Adjustment_Created_With_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajuste de envio creado. Link de pago: ${i?.url}`)
};

/**
* | output |
* | --- |
* | "Shipping adjustment created. Payment link: {url}" |
*
* @param {Shipping_Adjustment_Created_With_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_created_with_link = /** @type {((inputs: Shipping_Adjustment_Created_With_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_Created_With_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_created_with_link(inputs)
	return es_shipping_adjustment_created_with_link(inputs)
});